import axios from "../../axios"

const header = (token) => {
  return {
    headers: {
      Authorization: "Bearer "+ token
    }
  }
}

export default {
  async getAllUsers() {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + '/api/users';
    try {

      let users = await axios.get('', header());
      return users.data;

    } catch (Exception) {
      return [];
    }
  },
  async deleteUser(id, token) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + '/api/users/'+ id
    try {
      
      await axios.delete('', header(token));
      return true;

    } catch (Exception) {
      return false;
    }
  },
  async alterUser(id, token, alterObject) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + '/api/users/'+ id
    try {

      await axios.put('', alterObject, header(token));
      return true;

    } catch(Exception) {
      return false;
    }
  },
  async addUser(token, data)
  {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + '/api/users';
    try {
      const response = await axios.post('', data, header(token));
      return response;
    } catch (error) {
      throw error;
    }
  },
  async alterUserEmail(id, token, email)
  {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + '/api/users/'+ id
    try {

      await axios.put('', {"email": email}, header(token));
      return true;

    } catch(Exception) {
      return false;
    }
  },
  async alterUserName(id, token, name)
  {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + '/api/users/'+ id
    try {

      await axios.put('', {"name": name}, header(token));
      return true;
      
    } catch(Exception) {
      return false;
    }
  },
  async alterUserUnblock(id, token, alterObject) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + '/api/users/'+ id
    try {
      await axios.patch('', alterObject, header(token));
      return true;

    } catch(Exception) {
      return false;
    }
  },
  async activityTwoFactor(id, token, alterObject) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + '/api/user-settings/'+ id
      return await axios.patch('', alterObject, header(token));
  },
  async isFuncionalUser(token) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + '/api/users/is-funcional-user';
    try {
      return await axios.get('', {...header(token)});
    } catch(Exception) {
      console.log(Exception);
      throw Exception;
    }
  },
}
